import { sendGTMEvent } from '@next/third-parties/google'
import {AnalyticsComponents, StepAnalytics} from "@/src/shared/models/analytics";
import {useContextStore} from "@/src/stores/useContextStore";
import {useStore} from "zustand";
import {analyticsStore} from "@/src/stores/useAnalyticsStore";
export const useAnalytics = () => {
    const { componentAnalytics } = useStore(analyticsStore);
    const contextVariables = useContextStore((state) => state.variables);
    const sendGtm = ({ eventName, eventValue }: Pick<StepAnalytics, "eventValue" | "eventName">) => {
        console.log("[test] (sendGtm) eventName ", eventName, " eventValue ", eventValue);
        sendGTMEvent({ event: eventName, value: eventValue });
    }
    const callAnalyticEvent = (analytics: StepAnalytics) => {
        const { eventName = "buttonClicked", eventValue, isContext = false } = analytics;

        if (isContext) {
            const contextRaw = contextVariables ?  contextVariables[eventValue] : null;

            contextRaw && sendGtm({
                eventName,
                eventValue: typeof contextRaw.value === "string" ? contextRaw.value : `${contextRaw.value}`
            });
        } else {
            sendGtm({ eventName, eventValue });
        }
    }

    const callComponentEvent = (componentId: AnalyticsComponents) => {
        const analytics = componentAnalytics.find(item => item.componentId === componentId)
        analytics && sendGtm({ eventName: analytics.eventName, eventValue: analytics.eventValue });
    }

    return { callAnalyticEvent, callComponentEvent }
}
